import { PageTransitionButtonContainer, PageTransitionContainer } from 'components/animations';
import { AppBar, Body, Button, PageLayout } from 'components/common';
import { usePageTransition } from 'hooks/animations';
import useUnderage from 'hooks/useUnderage';
import { useEffect, useRef, useState } from 'react';

const PageUnderAgeComplete: React.FC = () => {
  const [comment, setComment] = useState('');
  const [isComplete, setIsComplete] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showCompleteAnimation, setShowCompleteAnimation] = useState(false);
  const hasSubmittedRef = useRef(false);
  const animation = usePageTransition();
  const { getSubmissionData, reset, submit } = useUnderage();

  useEffect(() => {
    window.UnderagePageBridge?.setOnCompletePage(true);
    return () => {
      window.UnderagePageBridge?.setOnCompletePage(false);
    };
  }, []);

  useEffect(() => {
    if (isComplete) {
      setTimeout(() => {
        setShowCompleteAnimation(true);
      }, 100);
    }
  }, [isComplete]);

  const handleBack = () => {
    Transition.showPage(Def.PAGE_UNDERAGE_PICTURE_PREVIEW);
  };

  const handleSubmit = async () => {
    if (isSubmitting || hasSubmittedRef.current) return;

    const submissionData = getSubmissionData(comment);
    if (!submissionData) return;

    hasSubmittedRef.current = true;
    setIsSubmitting(true);

    try {
      await submit(submissionData);
      setIsComplete(true);
      reset();
    } catch (error) {
      // 실패 시 완료 화면으로 넘기지 않고 버튼을 되살려 재탭으로 재시도
      hasSubmittedRef.current = false;
      const hMainContainer = document.getElementById('hMainContainer');
      if (hMainContainer) {
        CommonUI.showToast(hMainContainer, { text: brsc.try_later, duration: 2000, position: 'top' });
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCommentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setComment(e.target.value.slice(0, 100));
  };

  if (isComplete) {
    return (
      <PageLayout>
        <div className="flex h-full items-center justify-center">
          <PageTransitionContainer isVisible={showCompleteAnimation} className="flex flex-col items-center justify-center gap-4">
            <img src="/imgweb/underage/ic_complete.svg" className="mb-3 h-14 w-14" alt="Complete" />
            <div className="mx-6 text-center typography-title-lg text-base-txt-primary">{brsc.age_verification_processing_title}</div>
            <div className="typography-body-sm text-base-txt-secondary">{brsc.age_verification_processing_contents}</div>
          </PageTransitionContainer>
        </div>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <AppBar onBack={handleBack} />

      <Body className="flex flex-col pb-[120px]">
        <PageTransitionContainer isVisible={animation.contentVisible} className="flex flex-1 flex-col items-start justify-start px-6 pt-6">
          <div className="w-full">
            <h1 className="mb-3 mt-0 typography-title-md text-base-txt-primary">{brsc.age_verification_complete}</h1>
            <div className="my-4 h-12 w-full rounded-md bg-base-bg-subtle p-3">
              <input
                type="text"
                className="h-full w-full bg-transparent typography-body-sm placeholder:text-input-txt-placeholder"
                placeholder={brsc.age_verification_opinion}
                value={comment}
                onChange={handleCommentChange}
                style={{ outline: 'none', border: 'none', boxShadow: 'none' }}
              />
            </div>
          </div>
        </PageTransitionContainer>

        <PageTransitionButtonContainer isVisible={animation.buttonVisible}>
          <Button
            style={{
              text: isSubmitting ? brsc.inprogress : brsc.confirm,
              color: 'btn-bg-primary',
              fontColor: 'white',
            }}
            onClick={isSubmitting || hasSubmittedRef.current ? undefined : handleSubmit}
            className="w-full"
          />
        </PageTransitionButtonContainer>
      </Body>
    </PageLayout>
  );
};

export default PageUnderAgeComplete;
